// extracted by mini-css-extract-plugin
module.exports = {"row":"Home_row__2kwtQ","col":"Home_col__2dvB-","card":"Home_card__1CWlb"};